import { Card } from 'antd';
import styled from 'styled-components';

export const CardLayoutWrapper = styled.div`
    background-color: #f2f2f2;
`;

export const Meta = styled(Card.Meta)`
    .ant-card-meta-title {
        font-weight: 600;
        font-size: 2rem;
        color: #383752;
    }
`;

export const SCard = styled(Card)<{ error?: boolean }>`
    --color: ${({ error }) => (error ? 'red' : '#cecece')};
    border-radius: 8px;
    border: none;
    background: white;
    margin-bottom: 2rem;

    .ant-card-body {
        padding: 2rem 2.5rem;
    }
`;

export const LFormCardContainer = styled.div<{
    template?: boolean;
    oneColumn?: boolean;
    normal?: boolean;
    viewOnly?: boolean;
    invoice?: boolean;
}>`
    display: grid;
    grid-template-columns: ${({ oneColumn }) => {
        if (oneColumn) {
            return 'repeat(2, minmax(0, 1fr))';
        }

        return '1fr';
    }};

    gap: ${({ viewOnly, oneColumn }) => {
        if (viewOnly) {
            return '0';
        }

        if (oneColumn) {
            return '0.5rem 1rem';
        }

        return '12px 40px';
    }};

    @media (min-width: 1600px) {
        grid-template-columns: ${({ template, invoice, viewOnly }) => {
            if (template || invoice || viewOnly) {
                return '1fr';
            }

            return 'repeat(2, minmax(0, 1fr))';
        }};
    }

    margin-bottom: ${({ invoice }) => {
        if (invoice) {
            return '1rem';
        }

        return '0';
    }};
`;

export const TagsContainer = styled.div`
    display: flex;
    gap: 1rem;
    margin-left: 2rem;
    align-items: center;
    span {
        margin: 0;
    }
`;
